import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Globe } from "lucide-react";
import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer className="bg-navy text-white" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <span className="bg-white rounded-md px-3 py-2 inline-flex mb-4">
            <Logo className="h-12" />
          </span>
          <p className="text-white/70 text-sm leading-relaxed max-w-xs">
            The AAWTA Driven Together Education Program connects individuals to careers in trucking,
            logistics, and supply chain through education, mentorship, and trusted partners.
          </p>
        </div>

        <div>
          <h4 className="font-display font-bold text-magenta uppercase tracking-widest text-xs mb-4">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="text-white/80 hover:text-magenta transition-colors">Home</Link></li>
            <li><Link to="/programs" className="text-white/80 hover:text-magenta transition-colors">Programs</Link></li>
            <li><Link to="/intake" className="text-white/80 hover:text-magenta transition-colors">Start Your Intake</Link></li>
            <li><Link to="/schedule" className="text-white/80 hover:text-magenta transition-colors">Schedule an Appointment</Link></li>
            <li><Link to="/contact" className="text-white/80 hover:text-magenta transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-magenta uppercase tracking-widest text-xs mb-4">
            African American Women Trucking Association
          </h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-2"><MapPin size={16} className="text-magenta mt-0.5 shrink-0" /> 5269 Buford Highway Suite 213, Buford, GA 30340</li>
            <li className="flex items-center gap-2"><Phone size={16} className="text-magenta shrink-0" /> <a href="tel:7707566768" className="hover:text-magenta">770-756-6768</a></li>
            <li className="flex items-center gap-2"><Mail size={16} className="text-magenta shrink-0" /> <a href="mailto:contact@aawta.org" className="hover:text-magenta">contact@aawta.org</a></li>
            <li className="flex items-center gap-2"><Globe size={16} className="text-magenta shrink-0" /> <a href="https://www.aawta.org" target="_blank" rel="noopener noreferrer" className="hover:text-magenta">www.aawta.org</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 mt-10 pt-6 text-center text-white/50 text-xs">
        © 2026 African American Women Trucking Association. All rights reserved.
      </div>
    </div>
  </footer>
);
